import { allManagePartnersRoutes, managePartnersBaseRoute } from '@atlassian/mpac-partners';
import React from 'react';

import NotFound from '../../../common/components/NotFound';
import AddonDiscoveryConfig from '../../records/AddonDiscoveryConfig';
import CollectionsConfig from '../../records/CollectionsConfig';
import VendorDetailsConfig from '../../records/VendorDetailsConfig';
import resolveAddonDiscoveryRoutes from './components/AddonDiscoveryRoutes/components/AddonDiscoveryRoutes';
import resolveAppListingRoutes from './components/AppListingRoutes/components/AppListingRoutes';
import AtlassianSupportsUkraineRouteHandler from './components/AtlassianSupportsUkraineRoute/components/AtlassianSupportsUkraineRouteHandler';
import SolutionsRouteHandler from './components/CategoriesRoutes/components/SolutionsRouteHandler';
import resolveCollectionsRoutes from './components/CollectionsRoutes/routes/CollectionsRoutes';
import ManagePartnersRouteHandler from './components/ManagePartnersRoutes/components/ManagePartnersRouteHandler';
import resolveVendorDetailsRoutes from './components/VendorDetailsRoutes/components/VendorDetailsRoutes';

import type { AMKTRoute } from './components/Routes.types';

type GetAllRoutesArgs = {
  addonDiscoveryConfig: AddonDiscoveryConfig;
  collectionsConfig: CollectionsConfig;
  vendorDetailsConfig: VendorDetailsConfig;
};

export default function getAllRoutes({
  addonDiscoveryConfig,
  collectionsConfig,
  vendorDetailsConfig,
}: GetAllRoutesArgs): AMKTRoute[] {
  return [
    ...resolveAddonDiscoveryRoutes({
      addonDiscoveryConfig,
    }),
    ...resolveCollectionsRoutes({
      collectionsConfig,
    }),
    {
      name: 'categoriesScreen',
      path: '/categories/:categoryId',
      exact: true,
      component: SolutionsRouteHandler,
    },
    ...resolveVendorDetailsRoutes({
      vendorDetailsConfig,
    }),
    ...resolveAppListingRoutes(),
    {
      name: 'managePartnersScreen',
      path: managePartnersBaseRoute,
      component: ManagePartnersRouteHandler,
    },
    {
      name: 'ukraineSupportScreen',
      path: '/atlassian-stands-with-ukraine',
      exact: true,
      component: AtlassianSupportsUkraineRouteHandler,
    },
    {
      name: 'notFoundScreen',
      // eslint-disable-next-line react/display-name
      render: (routeProps) => (
        <NotFound {...routeProps} homeLink={addonDiscoveryConfig.links.home} />
      ),
    },
    ...allManagePartnersRoutes,
  ];
}
